<template>
  <div>
    <px-view-header title="Cadastro de Nota de Entrada"
                    title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"
                    default-title-column-size="8"
                    default-breadcrumbs-column-size="4">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="loadingTipoNotaEntrada">
      <px-circular-loading/>
    </div>
    <v-container v-if="!loadingTipoNotaEntrada">
      <v-row dense>
        <v-col cols="12" sm="6">
          <v-text-field
            dense
            outlined
            required
            hide-details
            maxlength="100"
            class="required rounded-tag-small"
            label="Descrição"
            :error="$v.tipoNotaEntrada.descricao.$error"
            @blur="$v.tipoNotaEntrada.descricao.$touch()"
            v-model="tipoNotaEntrada.descricao"
          />
        </v-col>
        <v-col cols="12" sm="3">
          <v-text-field
            dense
            outlined
            hide-details
            maxlength="50"
            class="rounded-tag-small"
            label="Código interno"
            v-model="tipoNotaEntrada.codigoInterno"
          />
        </v-col>
        <v-col cols="12" sm="2">
          <v-switch dense
                    hide-details
                    class="pa-0 mt-2 mr-2"
                    label="Padrão"
                    color="primary"
                    v-model="tipoNotaEntrada.padrao"/>
        </v-col>
        <v-col cols="12" sm="1">
          <v-switch dense
                    hide-details
                    class="pa-0 mt-2 mr-2"
                    label="Ativo"
                    color="primary"
                    v-model="tipoNotaEntrada.ativo"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="10">
          <px-autocomplete-cfop
            dense
            outlined
            required
            class="required rounded-tag-small"
            label="CFOP no Estado"
            :error="$v.tipoNotaEntrada.noEstado.$error"
            @blur="$v.tipoNotaEntrada.noEstado.$touch()"
            v-model="tipoNotaEntrada.noEstado"
          />
        </v-col>
        <v-col cols="12" sm="2">
          <v-text-field
            dense
            outlined
            hide-details
            maxlength="255"
            class="rounded-tag-small"
            label="Variação"
            v-model="tipoNotaEntrada.variacaoNoEstado"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="10">
          <px-autocomplete-cfop
            dense
            outlined
            required
            class="required rounded-tag-small"
            label="CFOP no outro Estado"
            :error="$v.tipoNotaEntrada.outroEstado.$error"
            @blur="$v.tipoNotaEntrada.outroEstado.$touch()"
            v-model="tipoNotaEntrada.outroEstado"
          />
        </v-col>
        <v-col cols="12" sm="2">
          <v-text-field
            dense
            outlined
            hide-details
            maxlength="255"
            class="rounded-tag-small"
            label="Variação"
            v-model="tipoNotaEntrada.variacaoOutroEstado"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="10">
          <px-autocomplete-cfop
            dense
            outlined
            required
            class="required rounded-tag-small"
            label="CFOP da importação"
            :error="$v.tipoNotaEntrada.importacao.$error"
            @blur="$v.tipoNotaEntrada.importacao.$touch()"
            v-model="tipoNotaEntrada.importacao"
          />
        </v-col>
        <v-col cols="12" sm="2">
          <v-text-field
            dense
            outlined
            hide-details
            maxlength="255"
            class="rounded-tag-small"
            label="Variação"
            v-model="tipoNotaEntrada.variacaoImportacao"
          />
        </v-col>
      </v-row>
      <div class="mt-5">
        <v-btn color="primary"
               class="normal-btn-text rounded-tag-small elevation-0"
               @click="onClickSave"
               :loading="loading">
          Salvar
        </v-btn>
        <v-btn text class="normal-btn-text" @click="onClickBack">Cancelar</v-btn>
      </div>
    </v-container>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';
import AutocompleteCfop from '@/components/PxAutocompleteCfop.vue';
import TipoNotaEntradaService from './tipo-nota-entrada-service';

export default {
  mixins: [validationMixin],
  data() {
    return {
      loading: false,
      loadingTipoNotaEntrada: false,
      tipoNotaEntrada: {
        descricao: null,
        codigoInterno: null,
        noEstado: null,
        variacaoNoEstado: null,
        outroEstado: null,
        variacaoOutroEstado: null,
        importacao: null,
        variacaoImportacao: null,
        padrao: false,
        ativo: true,
      },
      tipoNotaEntradaId: this.$route.params.id,
      breadcrumbs: [
        { text: 'Empresa' },
        { text: 'Nota de Entrada' },
      ],
    };
  },
  methods: {
    onClickBack() {
      this.$router.push({ name: 'main.configuracoes-notas-entrada' });
    },
    getTipoNotaEntrada() {
      this.loadingTipoNotaEntrada = true;
      TipoNotaEntradaService.get(this.tipoNotaEntradaId)
        .then((response) => {
          this.tipoNotaEntrada = response.data;
        })
        .finally(() => {
          this.loadingTipoNotaEntrada = false;
        });
    },
    salvar() {
      this.loading = true;
      TipoNotaEntradaService.save(this.tipoNotaEntrada)
        .then(() => {
          if (this.tipoNotaEntradaId) {
            this.$toast('Tipo de nota de entrada atualizada com sucesso', { color: 'success' });
          } else {
            this.$toast('Tipo de nota de entrada criada com sucesso', { color: 'success' });
          }
          this.onClickBack();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClickSave() {
      if (this.validateForm()) {
        return;
      }
      this.salvar();
    },
  },
  created() {
    if (this.tipoNotaEntradaId) {
      this.getTipoNotaEntrada();
    }
  },
  validations: {
    tipoNotaEntrada: {
      descricao: {
        required,
      },
      noEstado: {
        required,
      },
      outroEstado: {
        required,
      },
      importacao: {
        required,
      },
    },
  },
  components: {
    PxAutocompleteCfop: AutocompleteCfop,
  },
};
</script>
